export const getAlbumUrl = (album: Album | ContentfulAlbum): string => {
	const title = 'title' in album ? album.title : album.name
	const identifier = 'id' in album ? album.id : album.number

	return `/browse/m/album/${title
		.replace(/[^a-zA-Z0-9]+/g, '-')
		.toLowerCase()}_${identifier}`
}

export const getComposerUrl = (composer: Composer | ContentfulArtist): string =>
	`/browse/m/composer/${composer.name
		.replace(/[^a-zA-Z0-9]+/g, '-')
		.toLowerCase()}_${composer.id}`

export const getTrackUrl = (track: Track): string =>
	`/browse/m/track/${track.title
		.replace(/[^a-zA-Z0-9]+/g, '-')
		.toLowerCase()}_${track.id}`
